// pp-calc-calibre-bolsa.js — ¿Qué Calibre de Bolsa Necesito?
// (/pages/que-calibre-de-bolsa-necesito)
//
// La conversión física es la única verdad dura del tema (la misma que usa el
// verificador de emplaye): micras = calibre × 0.254. El calibre (gauge) es la
// escala con la que se vende bolsa en México — cal 125 = 31.8 µm — y 1 mil son
// 25.4 µm, así que calibre 100 = 1 mil exacto.
//
// La RECOMENDACIÓN por rangos de peso es tabla EDITORIAL de Para Paquetes
// (experiencia práctica de venta, no una norma): <1 kg → cal 125–150,
// 1–5 kg → 150–200, 5–15 kg → 200–300, >15 kg → 300+. Con filos o puntas se
// sube un escalón (+50 de calibre) porque el riesgo es punción, no carga.
// Aritmética pura probada en tests/calc-calibre-bolsa.test.mjs.
(function (root) {
  'use strict';

  var MICRAS_POR_CALIBRE = 0.254;
  var MICRAS_POR_MIL = 25.4;
  var ESCALON_FILOS = 50;

  // Tabla editorial: [pesoMaxKg (exclusivo por abajo, inclusivo por arriba),
  // calibreMin, calibreMax]. El último rango es abierto (max null = "300+").
  var RANGOS = [
    { hastaKg: 1, calibreMin: 125, calibreMax: 150 },
    { hastaKg: 5, calibreMin: 150, calibreMax: 200 },
    { hastaKg: 15, calibreMin: 200, calibreMax: 300 },
    { hastaKg: null, calibreMin: 300, calibreMax: null }
  ];

  // Contexto editorial por tipo de contenido — alimenta la nota del veredicto,
  // no mueve el rango (el rango lo deciden peso y filos).
  var TIPOS = {
    ropa: 'La ropa y los textiles son blandos y reparten el peso: el rango por peso te sobra, y una bolsa lisa se desliza mejor en la mesa de empaque.',
    documentos: 'Los documentos pesan poco pero se doblan: aquí el calibre protege rigidez y presentación, no carga.',
    ligeras: 'Para piezas ligeras el enemigo es el rasgón en esquinas durante el manejo, no el peso.',
    medianas: 'Las piezas medianas ya trabajan la bolsa en el traslado: quédate en la mitad alta del rango si el trayecto es largo.',
    pesadas: 'Con piezas pesadas o voluminosas la bolsa carga en las costuras: el rango alto no es lujo, es que no se abra en el camino.'
  };

  function micrasDeCalibre(calibre) {
    var c = num(calibre);
    return c === null ? null : c * MICRAS_POR_CALIBRE;
  }

  function calibreDeMicras(micras) {
    var m = num(micras);
    return m === null ? null : m / MICRAS_POR_CALIBRE;
  }

  function milsDeCalibre(calibre) {
    var m = micrasDeCalibre(calibre);
    return m === null ? null : m / MICRAS_POR_MIL;
  }

  // Entradas: tipo ('ropa'|'documentos'|'ligeras'|'medianas'|'pesadas'),
  // pesoKg (> 0), filos (boolean). Devuelve el rango recomendado en las tres
  // unidades + la nota editorial, o null si falta algo.
  function recomendar(e) {
    if (!e) return null;
    var peso = num(e.pesoKg);
    if (peso === null || peso <= 0) return null;
    var notaTipo = TIPOS[e.tipo];
    if (!notaTipo) return null;

    var rango = null;
    for (var i = 0; i < RANGOS.length; i++) {
      if (RANGOS[i].hastaKg === null || peso <= RANGOS[i].hastaKg) { rango = RANGOS[i]; break; }
    }

    var extra = e.filos ? ESCALON_FILOS : 0;
    var min = rango.calibreMin + extra;
    var max = rango.calibreMax === null ? null : rango.calibreMax + extra;

    return {
      calibreMin: min,
      calibreMax: max,
      micrasMin: min * MICRAS_POR_CALIBRE,
      micrasMax: max === null ? null : max * MICRAS_POR_CALIBRE,
      milsMin: (min * MICRAS_POR_CALIBRE) / MICRAS_POR_MIL,
      milsMax: max === null ? null : (max * MICRAS_POR_CALIBRE) / MICRAS_POR_MIL,
      conEscalonFilos: !!e.filos,
      notaTipo: notaTipo
    };
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcCalibre = {
    MICRAS_POR_CALIBRE: MICRAS_POR_CALIBRE,
    MICRAS_POR_MIL: MICRAS_POR_MIL,
    ESCALON_FILOS: ESCALON_FILOS,
    RANGOS: RANGOS,
    micrasDeCalibre: micrasDeCalibre,
    calibreDeMicras: calibreDeMicras,
    milsDeCalibre: milsDeCalibre,
    recomendar: recomendar
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-calibre-bolsa]');
    if (!raiz) return;
    var C = window.PPCalcCalibre;
    var form = raiz.querySelector('form');
    var out = raiz.querySelector('[data-calc-resultado]');

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec });
    }

    function rangoTexto(min, max, unidad, dec) {
      if (max === null) return fmt(min, dec) + '+ ' + unidad;
      return fmt(min, dec) + '–' + fmt(max, dec) + ' ' + unidad;
    }

    function correr() {
      var f = new FormData(form);
      var r = C.recomendar({
        tipo: f.get('tipo'),
        pesoKg: f.get('peso'),
        filos: f.get('filos') !== null
      });
      pintar(r);
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: el peso debe ser mayor a cero.</p>';
        return;
      }
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
      html += '<p class="pp-calc__veredicto-titulo">Calibre recomendado: ' + rangoTexto(r.calibreMin, r.calibreMax, '', 0).replace(/ $/, '') + '</p>';
      html += '<p class="pp-calc__veredicto-dato">El mismo espesor en las tres escalas: <strong>' + rangoTexto(r.calibreMin, r.calibreMax, 'de calibre', 0) + '</strong> = <strong>' + rangoTexto(r.micrasMin, r.micrasMax, 'micras', 1) + '</strong> = <strong>' + rangoTexto(r.milsMin, r.milsMax, 'mils', 2) + '</strong>.</p>';
      if (r.conEscalonFilos) {
        html += '<p class="pp-calc__veredicto-dato">Ya incluye el escalón por filos o puntas (+50 de calibre): el riesgo ahí es punción, no peso.</p>';
      }
      html += '</div>';
      html += '<p class="pp-calc__nota">' + r.notaTipo + ' Esta es la recomendación práctica de Para Paquetes por experiencia de venta — no una norma: si tu envío viaja apretado o con manejo rudo, súbete al tope del rango.</p>';
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr();
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
